import { render, staticRenderFns } from "./croupiers.vue?vue&type=template&id=7b7f130f&scoped=true&"
import script from "./croupiers.vue?vue&type=script&lang=js&"
export * from "./croupiers.vue?vue&type=script&lang=js&"
import style0 from "./croupiers.vue?vue&type=style&index=0&id=7b7f130f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7f130f",
  null
  
)

export default component.exports